import React, { useEffect, useState } from "react";
import "./Card.css";
import { Link } from "react-router-dom";

const Cards = ({ movie }) => {
    return ( <Link to={`/movie/${movie.id}`} style={{ textDecoration: "none", color: "white" }}>
                    <div className="Card">
                        <div className="cardInner">
                            <div className="cardFront">
                                <img
                                    className="movieCardImage"
                                    src={`https://image.tmdb.org/t/p/original${movie.poster_path || ""}`}
                                    alt={movie.original_title || "Movie Poster"}
                                    style={{ width: "100%", height: "100%", objectFit: "cover"}}
                                />
                            </div>
                            <div className="cardBack">
                                <div>
                                    <div className="movieCardTitle">{movie.original_title || ""}</div>
                                    <div className="movieCardRuntime">
                                        {movie.release_date || ""}
                                        <span className="movieCardRating">
                                            {movie.vote_average || ""}
                                        </span>
                                    </div>
                                    <div className="movieCardDescription">
                                        {movie.overview ? movie.overview.slice(0, 100) + "..." : ""}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Link>
    );
};

export default Cards;